<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang';

  import { radio, datepicker } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';
  
  export default {
    components: { datepicker, radio, CabecalhoRelatorio, TelaCheia },
    data() {
      return {
        filtros: {
          idProjeto: '',
          dataInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataFim: moment(new Date()).format('DD/MM/YYYY'),
          idRubrica: '',
          idSubrubrica: '',
          idMetaEtapa: '',
          tipoProvisao: '',
          situacao: 0,
        },
        projetos: [],
        rubricas: [],
        subrubricas: [],
        metaEtapas: [],
        relatorio: [],
        tiposProvisao: [],
        projeto: null,
        dataInicio: null,
        dataFim: null,
        rubrica: null, 
        subrubrica: null, 
        metaEtapa: null, 
        tipoProvisao: null, 
        configuracao: this.$storage.configuracao(),
        valorProvisaoPagar: 0,
        valorProvisaoReceber:0,
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelProvisao")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaDeMetaEtapas() {
        return projetoServico
          .metaEtapasProjeto(this.filtros.idProjeto)
          .then(metaEtapas => {
            this.metaEtapas = metaEtapas;
          });
      },
      listaDeRubricas() {
        return projetoServico
          .rubricasProjeto(this.filtros.idProjeto, this.filtros.idMetaEtapa)
          .then(rubricas => {
            this.rubricas = rubricas;
          });
      },
      listaDeSubrubricas() {
        this.filtros.idSubrubrica = '';
        
        if (this.projetoSelecionado.utilizarMetaEtapaProjeto && this.filtros.idMetaEtapa !== '' && this.filtros.idRubrica === '') {
          this.subrubricas = [];
          return;
        }
        
        return projetoServico
          .subrubricasProjeto(this.filtros.idProjeto, this.filtros.idRubrica, this.filtros.idMetaEtapa)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      listaDeTiposProvisoes() {
        this.tiposProvisao= [
                              {nome:'Compras', id: '9'},
                              {nome:'Compras e Licitação', id: '11'},
                              {nome:'Imposto - COFINS', id: '5'},
                              {nome:'Imposto - CSLL', id: '7'}, 
                              {nome:'Imposto - INSS projeto', id: '2'},
                              {nome:'Imposto - INSS retenção', id: '3' },
                              {nome:'Imposto - IRRF', id: '1' },
                              {nome:'Imposto - ISS', id: '4' },
                              {nome:'Imposto - PIS', id: '6' },
                              {nome:'Licitação', id: '10'},
                              {nome:'Outros (entrada manual)', id: '13'},
                              {nome:'Repasse', id: '12'},
                              {nome:'Valor Seguro', id: '8'},
                            ];
      },
      gerar() {
        this.relatorio = [];
        this.setarProjeto();
        this.setarRubrica();
        this.setarSubrubrica();
        this.setarMetaEtapa();
        this.setarTipoProvisao();
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;

        this.valorProvisaoPagar = 0;
        this.valorProvisaoReceber = 0;
        
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');
            
            return relatorioServico.provisoesProjeto(this.filtros);
          })
          .then(resultado => {
            this.relatorio = resultado.lancamentos;
            this.valorProvisaoPagar = resultado.provisaoDebitoAberto;
            this.valorProvisaoReceber = resultado.provisaoCreditoAberto;
            
            $('#gerar').button('reset');
            
            if (this.relatorio.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      gerarExcel() {
        this.relatorio = [];
        this.setarProjeto();
        this.setarRubrica();
        this.setarSubrubrica();
        this.setarMetaEtapa();
        this.setarTipoProvisao();
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;

        this.valorProvisaoPagar = 0;
        this.valorProvisaoReceber = 0;

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");

            $('#gerar-excel').button('loading');

            return relatorioServico.provisoesProjetoExcel(this.filtros)
          })
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
      setarProjeto() {
        const idProjeto = this.filtros.idProjeto;

        this.projeto = idProjeto ? this.projetos.find(p => p.idProjeto == idProjeto) : null; 
      },
      setarRubrica() {
        const idRubrica = this.filtros.idRubrica;

        this.rubrica = idRubrica ? this.rubricas.find(r => r.id == idRubrica) : null; 
      },
      setarSubrubrica() {
        const idSubrubrica = this.filtros.idSubrubrica;

        this.subrubrica = idSubrubrica ? this.subrubricas.find(s => s.id == idSubrubrica) : null; 
      },
      setarMetaEtapa() {
        const idMetaEtapa = this.filtros.idMetaEtapa;

        this.metaEtapa = idMetaEtapa ? this.metaEtapas.find(me => me.idProjetoMetaEtapa == idMetaEtapa) : null; 
      },
      setarTipoProvisao() {
        const tipoProvisao = this.filtros.tipoProvisao;

        this.tipoProvisao = tipoProvisao ? this.tiposProvisao.find(tp => tp.id == tipoProvisao) : null; 
      },
      historicoProvisao(p) {
        let historico = ''; 

        if (p.observacaoProvisao != '')
          historico = p.historico + ' - ' + p.observacaoProvisao
        else
          historico = p.historico;

        return historico;
      },
      tipoImposto(p) {
        let nomeImposto = "";
          
        switch (p.tipoImposto) {
          case 1:
              nomeImposto = 'IRRF';
              break;
          case 2:
            if (p.tipoPessoa == 1)
                nomeImposto = 'INSS projeto';
            else
                nomeImposto = 'INSS retenção';
            break;
          case 3:
              nomeImposto = 'INSS retenção';
              break;
          case 4:
              nomeImposto = 'ISS';
              break;
          case 5:
              nomeImposto = 'COFINS';
              break;
          case 6:
              nomeImposto = 'PIS';
              break;
          case 7:
              nomeImposto = 'CSLL';
              break;
          case 10:
              nomeImposto = 'Valor Seguro';
              break;
          case 20:
              nomeImposto = 'Repasse';
              break;
          default:
              nomeImposto = '---';
              break;
        }

        return nomeImposto;
      },
      corTipoProvisao(p) {
        if (p == 1)
          return "color:red"
        else
          return "color:blue";
      },
      retornaValor(p) {
        let valor = 0.0;

        if (p.tipoProvisao == 1) {
          valor -= p.valorProvisionado;
        } else {
          valor += p.valorProvisionado;
        }

        return valor;
      },
    },
    computed: {
      projetoSelecionado() {
        const idProjeto = this.filtros.idProjeto;
        
        return idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : {};
      },
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Provisões`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();
      this.listaDeTiposProvisoes();
      
      const _this = this;

      //$('.datepicker input').attr('readonly', '');

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
        
        _this.filtros.idMetaEtapa = '';
        _this.filtros.idRubrica = '';
        _this.filtros.idSubrubrica = '';
        
        if (_this.projetoSelecionado.utilizarMetaEtapaProjeto) {
          _this.listaDeMetaEtapas();
        }
        
        _this.listaDeRubricas();
        _this.listaDeSubrubricas();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<style scoped>
  .provisaoBaixada {
    font-size: 1.40em;
    color: #7ec874;
  }
</style>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
                <label class="control-label">Período</label>

                <datepicker id="dataInicio"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataInicio"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                <label class="control-label">&nbsp; &nbsp;</label>

                <datepicker id="dataFim"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataFim"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select id="projeto"
                        class="form-control"
                        v-model="filtros.idProjeto"
                        data-vv-name="projeto"
                        v-validate="'required'">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

          <div class="row" v-if="projetoSelecionado.utilizarMetaEtapaProjeto">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="metaEtapa">Meta Etapa</label>

                <select id="metaEtapa"
                        class="form-control"
                        v-model="filtros.idMetaEtapa"
                        @change="listaDeRubricas(); listaDeSubrubricas();">
                  <option value="">Selecione...</option>
                  <option :value="metaEtapa.idProjetoMetaEtapa" v-for="metaEtapa in metaEtapas">{{ metaEtapa.meta.nome }} {{ metaEtapa.etapa.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="rubrica">Rubrica</label>

                <select id="rubrica"
                        class="form-control"
                        v-model="filtros.idRubrica"
                        @change="listaDeSubrubricas">
                  <option value="">Selecione...</option>
                  <option :value="rubrica.id" v-for="rubrica in rubricas">{{ rubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="subrubrica">Subrubrica</label>

                <select id="subrubrica"
                        class="form-control"
                        v-model="filtros.idSubrubrica">
                  <option value="">Selecione...</option>
                  <option :value="subrubrica.id" v-for="subrubrica in subrubricas">{{ subrubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="tipoProvisao">Tipo provisão</label>

                <select id="tipoProvisao"
                        class="form-control"
                        v-model="filtros.tipoProvisao">
                  <option value="">Selecione...</option>
                  <option :value="tipo.id" v-for="tipo in tiposProvisao">{{ tipo.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-1">
              <div class="form-group">
                <radio v-model="filtros.situacao"
                       :selected-value="0"
                       type="success">
                  Todas
                </radio>
              </div>
            </div>

            <div class="col-xs-1">
              <div class="form-group">
                <radio v-model="filtros.situacao"
                       :selected-value="1"
                       type="success">
                  Baixadas
                </radio>
              </div>
            </div>

            <div class="col-xs-1">
              <div class="form-group">
                <radio v-model="filtros.situacao"
                       :selected-value="2"
                       type="success">
                  Não baixadas
                </radio>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button id="gerar"
                    type="button"
                    class="btn btn-primary"
                    @click="gerar"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i>
              Gerar relatório
            </button>

            <button id="gerar-excel"
                    type="button"
                    class="btn btn-primary"
                    @click="gerarExcel"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-table"></i>
              Gerar relatório em excel
            </button>

            <tela-cheia texto="Visualizar em tela cheia"
                        icone="arrows-alt"
                        v-if="relatorio.length > 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio :titulo="`Relatório de Provisões`" borda=""></cabecalho-relatorio>

    <div class="row" v-if="relatorio.length > 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            
            <div class="table-responsive">
              <table class="table relatorio table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Projeto</th>
                    <th v-if="metaEtapa">Meta Etapa</th>
                    <th v-if="rubrica">Rubrica</th>
                    <th v-if="subrubrica">Subrubrica</th>
                    <th class="text-right">Período</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ projeto.nomeProjeto }}</td>
                    <td v-if="metaEtapa">{{ metaEtapa.meta.nome }} {{ metaEtapa.etapa.nome }}</td>
                    <td v-if="rubrica">{{ rubrica.nome }}</td>
                    <td v-if="subrubrica">{{ subrubrica.nome }}</td>
                    <td class="text-right">{{ dataInicio }} - {{ dataFim }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table relatorio table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    <th>Data</th>
                    <th class="text-center">Nº sol. web</th>
                    <th class="text-center">Nº sol. compra</th>
                    <th class="text-center">Nº sol. licitação</th>
                    <th class="text-center">Nº pedido de compra</th>
                    <th class="text-center">P/R</th>
                    <th>Tipo Provisão</th>
                    <th>Histórico</th>
                    <th v-if="projetoSelecionado.utilizarMetaEtapaProjeto">Meta Etapa - Rubrica - Subrubrica</th>
                    <th v-if="!projetoSelecionado.utilizarMetaEtapaProjeto">Rubrica - Subrubrica</th>
                    <th class="text-right">Valor Provisionado (R$)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(provisao, indice) in relatorio">
                    <td class="text-center">
                      <div v-if="provisao.baixa">
                        <i class="fa fa-check provisaoBaixada" v-tooltip="'Baixada'"></i>
                      </div>
                    </td>
                    <td>{{ provisao.data | formatarData }}</td>
                    <td class="text-center">{{ (provisao.solCompraWEB == 0) ? '---' : provisao.solCompraWEB }}</td>
                    <td class="text-center">{{ provisao.compra || '---' }}</td>
                    <td class="text-center">{{ provisao.licitacao || '---' }}</td>
                    <td class="text-center">{{ provisao.pedidoCompra || '---' }}</td>
                    <td class="text-center" :style="corTipoProvisao(provisao.tipoProvisao)">{{ (provisao.tipoProvisao == 1) ? 'P' : 'R' }}</td>
                    <td>{{ tipoImposto(provisao) }}</td>
                    <td>{{ historicoProvisao(provisao) }} </td>
                    <td v-if="projetoSelecionado.utilizarMetaEtapaProjeto">{{ provisao.nomeMeta }} - {{ provisao.nomeEtapa }} - {{ provisao.nomeRubrica }} - {{ provisao.nomeSubRubrica }}</td>
                    <td v-if="!projetoSelecionado.utilizarMetaEtapaProjeto">{{ provisao.nomeRubrica }} - {{ provisao.nomeSubRubrica }}</td>
                    <td class="text-right">{{ retornaValor(provisao) | formatarNumero }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table relatorio table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Total pendente a receber: {{ this.valorProvisaoReceber | formatarNumero }}</th>
                    <th>Total pendente a pagar: {{ this.valorProvisaoPagar | formatarNumero }}</th>
                    <th>Diferença: {{ (this.valorProvisaoReceber + this.valorProvisaoPagar) | formatarNumero }}</th>
                  </tr>
                </thead>
              </table>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/Provisoes.vue